import { Link } from 'react-router-dom';
import { PersonFill, ChevronRight } from 'react-bootstrap-icons';

export function AccountPageHeader({ icon, title, description, actions, breadcrumbs }) {
  return (
    <div className="acct-page-header">
      <nav className="acct-breadcrumb" aria-label="breadcrumb">
        <Link to="/myaccount" className="acct-breadcrumb-link">
          <PersonFill aria-hidden="true" /> My Account
        </Link>
        {breadcrumbs?.map((c, i) => (
          <span key={i} className="acct-breadcrumb-segment">
            <ChevronRight className="acct-breadcrumb-sep" aria-hidden="true" />
            <Link to={c.to} className="acct-breadcrumb-link">{c.label}</Link>
          </span>
        ))}
        <ChevronRight className="acct-breadcrumb-sep" aria-hidden="true" />
        <span className="acct-breadcrumb-current" aria-current="page">{title}</span>
      </nav>
      <div className="acct-page-header-row">
        <div className="acct-page-header-title">
          {icon && <span className="acct-page-header-icon" aria-hidden="true">{icon}</span>}
          <h2>{title}</h2>
        </div>
        {actions && <div className="acct-page-header-actions">{actions}</div>}
      </div>
      {description && <p className="acct-page-header-desc">{description}</p>}
    </div>
  );
}
